import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { copyPaywallCheckoutUrlWithPrefix } from "@circle-react/helpers/paywallCheckoutHelpers";
import { Icon } from "@circle-react-shared/Icon";
import { useToast } from "@circle-react-shared/uikit/ToastV2";

export const CopyLinkCell = ({ checkoutPath }) => {
  const toastr = useToast();

  return (
    <div className="flex h-6 w-20 items-center">
      <button
        type="submit"
        className="text-dark flex items-center text-xs font-medium"
        onClick={() => {
          copyPaywallCheckoutUrlWithPrefix(checkoutPath, "#paywalls-list");
          toastr.success(t("settings.paywalls.list.form.copy_url_toast"), {
            duration: "short",
            shouldUseProgress: false,
          });
        }}
      >
        <span className="flex h-5 w-5">
          <Icon type="20-copy" size={20} className="mr-2" />
        </span>
        <span>{t("settings.paywalls.list.form.copy_url")}</span>
      </button>
    </div>
  );
};

CopyLinkCell.propTypes = {
  checkoutPath: PropTypes.string.isRequired,
};
